// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"b649d649","353":"bdf5d445"}[chunkId] + ".js";
};